<div class="canvas-container">
    <canvas #canvasElement></canvas>
</div>
